/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "react", "../Common/KubeConsumer", "../Constants"], function (require, exports, React, KubeConsumer_1, Constants_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PodContentReader = /** @class */ (function (_super) {
        __extends(PodContentReader, _super);
        function PodContentReader() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        PodContentReader.prototype.render = function () {
            return KubeConsumer_1.getContentReaderComponent(__assign({}, this.props));
        };
        PodContentReader.prototype.componentDidMount = function () {
            this.props.markTTICallback && this.props.markTTICallback({
                "scenario": Constants_1.Scenarios.PodYaml
            });
        };
        return PodContentReader;
    }(React.Component));
    exports.PodContentReader = PodContentReader;
});
